// ANGULAR
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

// SERVICE
import { EmployeeStoreService } from '../../../../../state/modules/employee/employee-store.service';
import { MasterBusinessStoreService } from '../../../../../state/modules/master-business/master-business-store.service';

// CONSTANTS
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { EMPLOYEE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/employee';
import { MASTER_BUSINESS_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/master-business';
import { CUSTOM_SAVE_BUTTON_CONFIG, JOB_INFORMATION_FORM_CONTROLS, JOB_INFORMATION_FORM_MODEL } from './client-job-information.constant';

// UTILS
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { FormBaseUtil } from '../../../../shared/components/form-components/base_class/form-utils';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { BusinessConfigurationService } from '../../../../../state/modules/business-configuration/business-configuration.service';
import { BehaviorSubject, of } from 'rxjs';
import { MasterBusinessService } from '../../../../../state/modules/master-business/services/master-business.service';

@Component({
  standalone: false,
  selector: 'kt-client-job-information',
  templateUrl: './client-job-information.component.html',
  styleUrls: ['./client-job-information.component.scss'],
})
export class ClientJobInformationComponent extends FormBaseUtil implements OnInit, AfterViewInit {

  currentRole = 0;

  /**
    * External inputs
    */
  @Input() options;
  @Input() set jobInformationForm(value) {
    this._jobInformationForm = value ? value : new UntypedFormGroup({});
    this._jobInformationForm.addControl('employee_id', this.fb.control(0));
  }
  @Input() set employeeData(value) {
    if (value) {
      this._employeeData = value;
      this.currentRole = this._employeeData.employee_fk_access_level_id || 0;
      this.setLoggedInUserProfile();

      if (this._employeeData && this._employeeData.employee_id && this._jobInformationForm) {
        this._jobInformationForm.get('employee_id').setValue(this._employeeData.employee_id);
      }
      // set value of job information form
      if (this._jobInformationForm) {
        const formatedData = this.convertModelToFormValue(JOB_INFORMATION_FORM_MODEL, this._employeeData);
        this._jobInformationForm.patchValue(formatedData, { emitEvent: false });
      }
    }
  }


  /**
 * External outputs
 */
  @Output() callback = new EventEmitter<any>();

  /**
   * Constants
   */
  formConstants = JOB_INFORMATION_FORM_CONTROLS;
  buttonConstants = CUSTOM_SAVE_BUTTON_CONFIG;
  lookupOptions: any = {
    employee_fk_access_level_id: new BehaviorSubject<any[]>([]),
  };
  _jobInformationForm: UntypedFormGroup;
  _employeeData = null;
  loading = signal(false);
  permissionConstant = PERMISSION_CONSTANT;
  isLoggedInUserProfile = false;
  subsciptions = [];

  constructor(private employeeStoreService: EmployeeStoreService,
    public masterBusinessStoreService: MasterBusinessStoreService,
    public masterBusinessService: MasterBusinessService,
    private fb: UntypedFormBuilder,
    private businessConfigurationService: BusinessConfigurationService,) {
    super();
  }

  ngOnInit() {
    this.dispatchMasterBusiness();
    // this.setLookupData();
  }

  ngAfterViewInit() {
    if (this._employeeData && this._jobInformationForm) {
      const formatedData = this.convertModelToFormValue(JOB_INFORMATION_FORM_MODEL, this._employeeData);
      this._jobInformationForm.patchValue(formatedData, { emitEvent: false });
    }
  }

  setLoggedInUserProfile() {
    const loginUserId = LocalStorageUtil.getUserId();
    if (loginUserId === this._employeeData.employee_fk_user_id) {
      this.isLoggedInUserProfile = true;
    } else {
      this.isLoggedInUserProfile = false;
    }
  }


  // ----------------- Begin: Selectors --------------- //

  /**
   * Set Dropdown options
   */
  // setLookupData() {
  //   this.lookupOptions.employee_fk_access_level_id = this.masterBusinessStoreService.selectEmployeeRoleList();
  // }

  // ----------------- End: Selectors --------------- //

  /**
   * save the job information of employee
   */
  saveJobInformation() {
    if (this._jobInformationForm.invalid) {
      Object.keys(this._jobInformationForm.controls).forEach(controlName =>
        this._jobInformationForm.controls[controlName].markAsTouched(),
      );

      return;
    }

    this.loading.set(true);

    const payload = this.convertFormValueToModel(JOB_INFORMATION_FORM_MODEL, this._jobInformationForm.value);
    // console.log('payload:', payload)
    /** dispatch employee common action */
    this.employeeStoreService.dispatchEmployeeCommon({
      callback: this.jobInformationCallBack.bind(this, payload), data: payload,
      module: EMPLOYEE_METHOD_CONSTANT.EMPLOYEE_JOB_INFORMATION,
      method: API_METHOD_CONSTANTS.UPDATE,
    });
  }

  /**
   * callback of job information api call
   */
  jobInformationCallBack(payload, data) {
    this.loading.set(false);
    if (data.success) {
      if (data.response) {
        this.isRoleChange(payload);
        this.callback.emit({ data: data.response, type: 'CALLBACK_DATA' });
        this._jobInformationForm.markAsPristine();
      }
    }
  }

  isRoleChange(payload) {
    const loginUserId = LocalStorageUtil.getUserId();
    if (loginUserId === this._employeeData.employee_fk_user_id && this.currentRole && payload && this.currentRole != payload.employee_fk_access_level_id) {
      location.reload();
    }
  }

  // ----------------- Begin: Dispatch --------------- //
  /**
   * Dispatch master business
   */
  dispatchMasterBusiness() {
    // this.masterBusinessStoreService.dispatchMasterBusinessCommon({
    //   module: MASTER_BUSINESS_METHOD_CONSTANT.STRESS_PROFILE, method: API_METHOD_CONSTANTS.GET_LOOKUP, callback: () => {
    //     setTimeout(() => {
    // this.masterBusinessStoreService.dispatchMasterBusinessCommon({ module: MASTER_BUSINESS_METHOD_CONSTANT.EMPLOYEE_ROLE, method: API_METHOD_CONSTANTS.GET_LOOKUP });
    this.masterBusinessService.getBusinessRole().subscribe(data => {
      if (data.success) {
        this.lookupOptions.employee_fk_access_level_id.next(data.data.data.business_role || []);
      }
    });
    //     }, 100);
    //   },
    // });

  }

  // ----------------- End: Dispatch --------------- //
}
